import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeTimeSideBar } from "../../../Hooks/changeTime";
import {
  toggleSidebar,
  toogleConversation,
} from "../../../Redux/reducers/responsiveHandle";

export default function SidebarUser({
  userId,
  userAvatar,
  userName,
  lastMessage,
  time,
  id,
  isMe,
  showBold,
  onPressed
}) {
  const dispatch = useDispatch();
  const currConversationId = useSelector((state) => state.conversationId.id);
  const [nepTime, setNepTime] = useState();
  // const [recentMessage, setRecentMessage] = useState(lastMessage);


  // const socket = useSocket();
  // const currRole = useSelector((state) => state.chatRole.role);



  useEffect(() => {
    const newTime = changeTimeSideBar(time);
    setNepTime(newTime);
  }, [time]);

  return (
    <>
      <div
        className="single-seller cursor-pointer"
        onClick={() => {
          dispatch(toogleConversation());
          dispatch(toggleSidebar());
          onPressed()
        }}
        style={{
          backgroundColor: userId === currConversationId && "#cfd2d580",
          borderBottom: '0.5px solid #ededed'
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            gap: "5px",
          }}
        >
          <img
            src={
              userAvatar ||
              "https://ui-avatars.com/api/?background=ec008c&color=ffffff&name=" +
              userName
            }
            alt={userName}
          />
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
              justifyContent: "center",
              paddingTop: "10px",
            }}
          >
            <h4 style={{ textOverflow: "ellipsis" }}>{userName.substring(0, 20)}{(userName).length > 20 ? '...' : ''}</h4>
            <p
              style={{ fontWeight: showBold ? "600" : "400", textOverflow: "ellipsis" }}
            >{`${isMe ? 'You:  ' : ''}${lastMessage}`}</p>
          </div>
        </div>
        <div>
          <span>{nepTime === 'Invalid Date' ? 'Just now' : nepTime}</span>
        </div>
      </div>
    </>
  );
}
